import React, { useState, useEffect } from "react";
import "./TestimonialSection.css";

// Student images
import student1 from "../Component/nandan-2.jpg";
import student2 from "../Component/Ajeet-yadav-2.jpg";
import student3 from "../Component/Akansha-yadav.jpg";
import student4 from "../Component/Khusi-bala.jpg";
import student5 from "../Component/Supriya.jpg";
import student6 from "../Component/rangoli.jpg";

// Background image
import bgImage from "../Component/bg-image.jpg";

const testimonials = [
  {
    id: 1,
    name: "Nandan Kushwaha",
    course: "O-Level",
    image: student1,
    text:
      "CPIT helped me build strong practical skills in web design. The trainers were supportive and guided me step-by-step. Today I can confidently create professional websites.",
  },
  {
    id: 2,
    name: "Ajeet Yadav",
    course: "O-Level",
    image: student2,
    text:
      "Learning at CPIT was a great experience. The training was practical and industry-focused. I gained confidence in UI/UX tools and now feel ready for real projects.",
  },
  {
    id: 3,
    name: "Akansha Yadav",
    course: "O-Level",
    image: student3,
    text:
      "CPIT helped me understand computer concepts in a very simple and practical way. The teachers are supportive and always ready to help. This training has improved my confidence and skills a lot.",
  },
  {
    id: 4,
    name: "Khusi Bala",
    course: "O-Level",
    image: student4,
    text:
      "Learning at CPIT was a good experience for me. The trainers focus on practical work and explain everything clearly. This course helped me build a strong base in computers.",
  },
  {
    id: 5,
    name: "Supriya",
    course: "O-Level",
    image: student5,
    text:
      "I had very little knowledge before joining CPIT, but the step-by-step teaching method made learning easy. The practical classes were very helpful and enjoyable. I am happy with my experience here.",
  },
  {
    id: 5,
    name: "Rangoli Gupta",
    course: "O-Level",
    image: student6,
    text:
      "CPIT provides a positive learning environment where teachers give personal attention to every student. The practical training helped me understand concepts clearly and improved my overall computer skills.",
  },
];

const TestimonialSection = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % testimonials.length);
    }, 2500);
    return () => clearInterval(interval);
  }, []);

  const handlePrev = () => {
    setCurrentIndex((prev) =>
      prev === 0 ? testimonials.length - 1 : prev - 1
    );
  };

  const handleNext = () => {
    setCurrentIndex((prev) => (prev + 1) % testimonials.length);
  };

  const { name, course, image, text } = testimonials[currentIndex];

  return (
    <div
      className="testimonial-section"
      style={{ backgroundImage: `url(${bgImage})` }}
    >
      <div className="testimonial-container">
        <div className="testimonial-left">
          <p className="subtitle">TESTIMONIAL</p>
          <h2 className="title">
            What Say Our <br /> Students
          </h2>
          <p className="description">
            CPIT provides practical and career-focused training to help students
            develop real skills, not just knowledge. Our experienced instructors
            guide each student with personal attention and support. We maintain a
            friendly and motivating learning environment where students gain
            confidence along with technical abilities.
          </p>
        </div>

        <div className="testimonial-right">
          <div className="testimonial-card">
            <i className="fa fa-quote-left quote-icon"></i>

            <p className="testimonial-text">{text}</p>

            <div className="student-info">
              <img
                src={image}
                alt={name}
                className="student-img"
                loading="lazy"
              />
              <div>
                <h4 className="student-name">{name}</h4>
                <p className="student-course">{course}</p>
              </div>
            </div>

            <div className="arrows">
              <button className="arrow prev" onClick={handlePrev}>
                <i className="fa fa-chevron-left"></i>
              </button>
              <button className="arrow next" onClick={handleNext}>
                <i className="fa fa-chevron-right"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TestimonialSection;
